/* PH B — winkelwagen (lade + pagina) en kleine toegankelijkheidsfixes: levering per product, regelprijs, overzichtsregels,
   notitie/kortingscode inklapbaar en zekerheden naast het overzicht.
   Alleen weergave: leest /cart.js en de bestaande knoppen; wijzigt geen winkelwagen- of productdata. */
(function () {
  'use strict';
  var el = document.getElementById('ph-cart-i18n');
  if (!el) return;
  var I = {};
  try { I = JSON.parse(el.textContent || '{}'); } catch (e) { return; }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cart = null, loading = null, stamp = '';

  function delim(n, prec, th, dec) {
    var p = (Math.abs(n) / 100).toFixed(prec).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return (n < 0 ? '-' : '') + p[0] + (p[1] ? dec + p[1] : '');
  }
  function money(c, cur) {
    var f = (cur ? I.moneyCur : I.money) || '€{{amount_with_comma_separator}}';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/), v;
    switch (m ? m[1] : 'amount_with_comma_separator') {
      case 'amount': v = delim(c, 2, ',', '.'); break;
      case 'amount_no_decimals': v = delim(c, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(c, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(c, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = delim(c, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = delim(c, 0, ' ', ','); break;
      default: v = delim(c, 2, '.', ',');
    }
    return m ? f.replace(m[0], v) : v;
  }
  function getCart(force) {
    if (cart && !force) return Promise.resolve(cart);
    if (loading) return loading;
    loading = fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; loading = null; return c; })
      .catch(function () { loading = null; return null; });
    return loading;
  }
  function itemByKey(key) {
    if (!cart || !key) return null;
    for (var i = 0; i < cart.items.length; i++) if (cart.items[i].key === key) return cart.items[i];
    return null;
  }
  function keyOf(row) {
    var b = row.querySelector('button[id^="remove-"]');
    if (b) return b.id.slice(7);
    var q = row.querySelector('input[id^="cart-qty-"]');
    return q ? q.id.slice(9) : null;
  }
  function stockOf(row) {
    var btns = row.querySelectorAll('button');
    for (var i = 0; i < btns.length; i++) {
      var a = btns[i].getAttribute('@click.prevent') || btns[i].getAttribute('x-on:click.prevent') || '';
      var m = a.match(/minusItemQty\('[^']*',\s*\d+,\s*'([^']*)',\s*'([^']*)',\s*(-?\d+)/);
      if (m) return { policy: m[1], managed: m[2] === 'shopify', qty: parseInt(m[3], 10) };
    }
    return null;
  }
  function make(tag, cls, html) { var n = document.createElement(tag); n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* B2 ronde 3: grote artikelen (zelfde regel als snippets/ph-b2-size.liquid) krijgen in NL/BE 2–3 werkdagen. */
  function phBig(it) {
    if (!it) return false;
    var t = it.product_type || '';
    if (t === 'Power Racks' || t === 'Pilates' || t === 'Ski Trainers' || t === 'Roeiapparaten') return true;
    return t === 'Dumbbells' && /set/i.test(it.product_title || '');
  }
  function statusNode(row) {
    var s = stockOf(row);
    if (!s) return null;
    if (!cart || !itemByKey(keyOf(row))) return null;
    var days = I.days || '';
    if (phBig(itemByKey(keyOf(row)))) days = days.replace('1–3', '2–3').replace('1 à 3', '2 à 3');
    if (!s.managed || s.qty > 0) return make('p', 'ph-ls', '<i aria-hidden="true"></i><b>' + esc(I.inStock) + '</b> · <span class="ph-nw">' + esc(days) + '</span>');
    if (s.policy === 'continue') return make('p', 'ph-ls ph-ls--pre', '<i aria-hidden="true"></i><b>' + esc(I.preorder) + '</b> · ' + esc(I.preorderText));
    return null;
  }

  function sumsHTML(withSub) {
    return (withSub ? '<div class="ph-sum"><span>' + esc(I.subtotal) + '</span><span>' + esc(money(cart.items_subtotal_price)) + '</span></div>' : '') +
      '<div class="ph-sum"><span>' + esc(I.shipping) + '</span><span class="ph-free">' + esc(I.free) + '</span></div>';
  }

  /* ---------------- Lade ---------------- */
  function enhanceDrawer() {
    var items = document.getElementById('CartDrawer-CartItems');
    if (!items) return;
    var rows = items.querySelectorAll('tr.cart-item');
    rows.forEach(function (row) {
      var col1 = row.querySelector('.product-info-column-1');
      var col2 = row.querySelector('.product-info-column-2');
      if (!col1 || !col2) return;
      if (!row.querySelector('.ph-ls')) {
        var t = col1.querySelector('a[href]');
        var st = statusNode(row);
        if (st && t) { var holder = t.closest('div') || t; var dl = col1.querySelector('dl'); if (dl && dl.textContent.trim()) holder = dl; holder.parentNode.insertBefore(st, holder.nextSibling); }
      }
      var it = itemByKey(keyOf(row));
      var lp = row.querySelector('.ph-lp');
      if (it) {
        var txt = money(it.final_line_price);
        if (!lp) { lp = make('span', 'ph-lp'); col2.insertBefore(lp, col2.firstChild); }
        if (lp.textContent !== txt) lp.textContent = txt;
      }
      var rm = row.querySelector('button[id^="remove-"], .cart-item__quantity button[aria-label]');
      if (rm && !rm.hasAttribute('data-ph')) { rm.setAttribute('data-ph', ''); rm.classList.add('ph-rm'); }
    });
    /* mobiel: aanbevelingen meescrollen met de producten, zodat het vaste deel klein blijft */
    var up = document.getElementById('mini-cart-upsell');
    var host = document.getElementById('CartDrawer-Form');
    host = host && host.parentNode;
    if (up && host && window.matchMedia('(max-width: 1023px)').matches && up.parentNode !== host) {
      up.classList.add('ph-up-moved'); host.appendChild(up);
    }
    var tot = document.querySelector('.cart-drawer-price-total');
    if (tot && cart) {
      var box = tot.querySelector('.ph-sums');
      if (!box) { box = make('div', 'ph-sums'); tot.insertBefore(box, tot.firstChild); }
      var html = sumsHTML(cart.items_subtotal_price !== cart.total_price);
      if (box.getAttribute('data-v') !== html) { box.setAttribute('data-v', html); box.innerHTML = html; }
      var lab = tot.querySelector('p.h4');
      if (lab && !lab.querySelector('small')) lab.insertAdjacentHTML('beforeend', '<small class="ph-vat">' + esc(I.inclVat) + '</small>');
    }
  }

  /* ---------------- Pagina ---------------- */
  var aside = null;
  function enhancePage() {
    var main = document.getElementById('main-cart-items');
    if (!main) return;
    document.documentElement.classList.add('ph-cartpage');
    main.querySelectorAll('tr.cart-item').forEach(function (row) {
      var tds = row.children;
      var info = tds[1];
      if (info && !row.querySelector('.ph-ls')) {
        var t = info.querySelector('a[href]');
        var st = statusNode(row);
        var holder = t ? (t.closest('div') || t) : null;
        var dl = info.querySelector('dl');
        if (dl && dl.textContent.trim()) holder = dl;
        if (st && holder) holder.parentNode.insertBefore(st, holder.nextSibling);
      }
      var it = itemByKey(keyOf(row));
      if (it && info && !info.querySelector('.ph-unit')) {
        info.appendChild(make('p', 'ph-unit', esc((I.perItem || '%p').replace('%p', money(it.final_price)))));
      }
      var rm = row.querySelector('button[id^="remove-"]');
      if (rm && !rm.querySelector('.ph-rm-t')) {
        rm.classList.add('ph-rm');
        rm.insertAdjacentHTML('beforeend', '<span class="ph-rm-t">' + esc(I.remove) + '</span>');
      }
    });
    var fc = main.querySelector('.form-checkout');
    if (!fc) return;
    if (!fc.querySelector('.ph-extra')) {
      var note = fc.querySelector('#x-cart-note-items');
      var noteBox = note ? note.closest('div') : null;
      var disc = fc.querySelector('[x-data^="xCouponCode"]');
      if (noteBox || disc) {
        var d = make('details', 'ph-extra');
        d.innerHTML = '<summary>' + esc(I.noteDiscount) + '</summary>';
        var body = make('div', 'ph-extra__body');
        d.appendChild(body);
        var anchor = fc.querySelector('#js-contents') || fc.firstChild;
        anchor.parentNode.insertBefore(d, anchor);
        if (disc) body.appendChild(disc);
        if (noteBox) body.appendChild(noteBox);
      }
    }
    var js = fc.querySelector('#js-contents');
    if (js && cart) {
      var box = fc.querySelector('.ph-sums');
      if (!box) {
        box = make('div', 'ph-sums');
        var ex = fc.querySelector('.ph-extra');
        (ex || js).parentNode.insertBefore(box, ex || js);
      }
      var html = sumsHTML(true);
      if (box.getAttribute('data-v') !== html) { box.setAttribute('data-v', html); box.innerHTML = html; }
      var lab = js.querySelector('p.h4');
      if (lab && !lab.querySelector('small')) lab.insertAdjacentHTML('beforeend', '<small class="ph-vat">' + esc(I.inclVat) + '</small>');
    }
    if (!aside) aside = document.querySelector('[data-ph-cart-aside]');
    if (aside) {
      var side = fc.parentNode.classList.contains('ph-cart-side') ? fc.parentNode : null;
      if (!side) {
        side = make('div', 'ph-cart-side');
        fc.parentNode.insertBefore(side, fc);
        side.appendChild(fc);
      }
      if (aside.parentNode !== side) side.appendChild(aside);
      aside.classList.add('is-placed');
    }
  }

  function tidy() {
    if (!I.taxNote) return;
    document.querySelectorAll('#update-cart p, #main-cart-items p').forEach(function (p) {
      if (!p.classList.contains('ph-hide') && p.textContent.replace(/\s+/g, ' ').trim() === I.taxNote) p.classList.add('ph-hide');
    });
  }

  /* vaste afrekenbalk op mobiel (alleen winkelwagenpagina) */
  var bar = null, io = null, watched = null;
  function mobileBar() {
    var main = document.getElementById('main-cart-items');
    var btn = main && main.querySelector('#checkout-submit-items');
    if (!btn || !cart) { if (bar) bar.classList.remove('is-on'); return; }
    if (!bar) {
      bar = make('div', 'ph-mbar');
      bar.innerHTML = '<span><small></small><strong></strong></span><button type="button"></button>';
      bar.querySelector('button').addEventListener('click', function () {
        var b = document.getElementById('checkout-submit-items'); if (b) b.click();
      });
      document.body.appendChild(bar);
    }
    bar.querySelector('small').textContent = (I.total || '') + ' ' + (I.inclVat || '');
    bar.querySelector('strong').textContent = money(cart.total_price);
    var label = btn.querySelector('.button-text');
    bar.querySelector('button').textContent = label ? label.textContent.trim() : '';
    if (watched !== btn && 'IntersectionObserver' in window) {
      if (io) io.disconnect();
      io = new IntersectionObserver(function (en) { bar.classList.toggle('is-on', !en[0].isIntersecting); });
      io.observe(btn); watched = btn;
    }
  }

  /* toegankelijkheid (A1, N3, A2): ontbrekende labels en een dubbele kop van de vaste koopbalk */
  function a11y() {
    /* aria-controls alleen laten staan als het doel bestaat (lade en mobiel menu laden pas later). */
    document.querySelectorAll('[aria-controls]').forEach(function (el) {
      var id = el.getAttribute('aria-controls');
      if (id && !document.getElementById(id)) { el.setAttribute('data-ph-controls', id); el.removeAttribute('aria-controls'); }
    });
    document.querySelectorAll('[data-ph-controls]').forEach(function (el) {
      var id = el.getAttribute('data-ph-controls');
      if (document.getElementById(id)) { el.setAttribute('aria-controls', id); el.removeAttribute('data-ph-controls'); }
    });
    document.querySelectorAll('.ph-trustbar__inner').forEach(function (el) { if (el.scrollWidth > el.clientWidth + 2 && !el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0'); });
    document.querySelectorAll('input[name="q"], input[type="search"], input[id^="header-search-in"]').forEach(function (i) {
      if (!i.getAttribute('aria-label') && !(i.id && document.querySelector('label[for="' + i.id + '"]'))) i.setAttribute('aria-label', I.search || 'Search');
    });
    document.querySelectorAll('input[name="filter.v.price.gte"]').forEach(function (i) { if (!i.getAttribute('aria-label')) i.setAttribute('aria-label', I.priceMin || ''); });
    document.querySelectorAll('input[name="filter.v.price.lte"]').forEach(function (i) { if (!i.getAttribute('aria-label')) i.setAttribute('aria-label', I.priceMax || ''); });
    var h1 = document.querySelector('h1.product-title');
    if (h1) document.querySelectorAll('h2.product-title').forEach(function (h) { if (h.textContent.trim() === h1.textContent.trim()) h.setAttribute('role', 'presentation'); });
  }

  function run() {
    var sig = '';
    document.querySelectorAll('#CartDrawer-CartItems tr.cart-item, #main-cart-items tr.cart-item').forEach(function (r) {
      var q = r.querySelector('input[id^="cart-qty-"]');
      sig += keyOf(r) + ':' + (q ? q.value : '') + ';';
    });
    var force = sig !== stamp;
    stamp = sig;
    getCart(force).then(function () { enhanceDrawer(); enhancePage(); tidy(); mobileBar(); });
    enhanceDrawer(); enhancePage(); tidy(); a11y();
  }
  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(run, 60); }
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var n = list[i].target;
      if (n.nodeType === 1 && (n.closest('#update-cart, #main-cart-items, #CartDrawer-CartItems') || n.querySelector && n.querySelector('#CartDrawer-CartItems, #main-cart-items'))) { schedule(); return; }
    }
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('eurus:cart:items-changed', schedule);
  /* A3: toetsenbord — focus naar de drawer bij openen, terug naar de knop bij sluiten. */
  var kb = false, opener = null, wasOpen = false;
  document.addEventListener('keydown', function () { kb = true; }, true);
  document.addEventListener('mousedown', function () { kb = false; }, true);
  document.addEventListener('touchstart', function () { kb = false; }, true);
  document.addEventListener('focusin', function (e) {
    var d = document.getElementById('CartDrawer');
    if (!d || !d.contains(e.target)) opener = e.target;
  });
  function drawerOpen(d) { return !!d && getComputedStyle(d).display !== 'none'; }
  function watchDrawer() {
    var d = document.getElementById('CartDrawer');
    if (!d || d.__phA11y) return;
    d.__phA11y = true;
    var cb = d.querySelector('#CloseCart');
    if (cb && !cb.getAttribute('aria-label')) cb.setAttribute('aria-label', (document.querySelector('#CartDrawer-Overlay') || {}).getAttribute ? document.querySelector('#CartDrawer-Overlay').getAttribute('aria-label') : 'Sluiten');
    d.setAttribute('role', 'dialog');
    d.setAttribute('aria-modal', 'true');
    var h = d.querySelector('.x-cart-heading p, .x-cart-heading h2');
    if (h) { if (!h.id) h.id = 'CartDrawer-Title'; d.setAttribute('aria-labelledby', h.id); }
    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !drawerOpen(d)) return;
      var f = [].filter.call(d.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, summary, [tabindex]:not([tabindex="-1"])'), function (n) {
        if (n.id === 'CartDrawer-Overlay') return false;
        var r = n.getBoundingClientRect(); return r.width > 0 && r.height > 0 && getComputedStyle(n).visibility !== 'hidden';
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !d.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !d.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    });
    new MutationObserver(function () {
      var open = drawerOpen(d);
      if (open && !wasOpen) {
        setTimeout(function () {
          if (kb && !d.contains(document.activeElement)) { var c = d.querySelector('#CloseCart'); if (c) c.focus(); }
        }, 320);
      } else if (!open && wasOpen) {
        setTimeout(function () {
          if (kb && opener && document.contains(opener) && (document.activeElement === document.body || d.contains(document.activeElement))) opener.focus();
        }, 320);
      }
      wasOpen = open;
    }).observe(d, { attributes: true, attributeFilter: ['style', 'class'] });
  }
  new MutationObserver(watchDrawer).observe(document.body, { childList: true, subtree: true });
  watchDrawer();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* ===== B2 premium-uitbreidingen (2026-10-14): leverdatum, vensters voor offerte en afspraak, formulierbevestiging ===== */
(function () {
  var HOLIDAYS = ['2026-12-25', '2026-12-26', '2027-01-01', '2027-03-28', '2027-03-29', '2027-04-27', '2027-05-06', '2027-05-16', '2027-05-17', '2027-12-25', '2027-12-26'];
  function amsterdamNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
      .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return { y: +parts.year, m: +parts.month, d: +parts.day, h: (+parts.hour) % 24, mi: +parts.minute };
  }
  function isoDay(dt) { return dt.toISOString().slice(0, 10); }
  function isWorkday(dt) { var w = dt.getUTCDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(isoDay(dt)) < 0; }
  function addWorkdays(dt, n) { var x = new Date(dt.getTime()); var c = 0; while (c < n) { x.setUTCDate(x.getUTCDate() + 1); if (isWorkday(x)) c++; } return x; }
  function renderEta(el) {
    try {
      var now = amsterdamNow();
      var today = new Date(Date.UTC(now.y, now.m - 1, now.d));
      var shipToday = isWorkday(today) && now.h < 12;
      var ship = shipToday ? today : addWorkdays(today, 1);
      var from = addWorkdays(ship, parseInt(el.getAttribute('data-min'), 10) || 1);
      var to = addWorkdays(ship, parseInt(el.getAttribute('data-max'), 10) || 3);
      var fmt;
      try { fmt = new Intl.DateTimeFormat(el.getAttribute('data-locale'), { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }); }
      catch (e) { fmt = new Intl.DateTimeFormat(undefined, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }); }
      el.textContent = '';
      var label = document.createElement('span');
      label.textContent = el.getAttribute('data-label') + ': ';
      var range = document.createElement('b');
      range.textContent = fmt.format(from) + ' – ' + fmt.format(to);
      el.appendChild(label); el.appendChild(range);
      if (shipToday) {
        var left = 12 * 60 - (now.h * 60 + now.mi);
        var hours = Math.floor(left / 60), minutes = left % 60;
        var time = hours > 0
          ? el.getAttribute('data-hm').split('%H%').join(String(hours)).split('%M%').join(String(minutes))
          : el.getAttribute('data-m').split('%M%').join(String(minutes));
        var cut = document.createElement('span');
        cut.className = 'ph-eta-cut';
        cut.textContent = el.getAttribute('data-cutoff').split('%T%').join(time);
        el.appendChild(cut);
      }
      el.hidden = false;
    } catch (err) { el.hidden = true; }
    el.setAttribute('data-done', '1');
  }
  function scanEta() { document.querySelectorAll('[data-ph-eta]:not([data-done])').forEach(renderEta); }
  var etaQueued = false;
  function queueEta() { if (etaQueued) return; etaQueued = true; requestAnimationFrame(function () { etaQueued = false; scanEta(); }); }

  function setupWeekday(input) {
    if (input.getAttribute('data-ph-wd') === '1') return;
    input.setAttribute('data-ph-wd', '1');
    var t = new Date(); t.setDate(t.getDate() + 1);
    var mm = String(t.getMonth() + 1); if (mm.length < 2) mm = '0' + mm;
    var dd = String(t.getDate()); if (dd.length < 2) dd = '0' + dd;
    input.min = t.getFullYear() + '-' + mm + '-' + dd;
    var check = function () {
      var v = input.value; var msg = '';
      if (v) { var d = new Date(v + 'T12:00:00Z'); var w = d.getUTCDay(); if (w === 0 || w === 6 || HOLIDAYS.indexOf(v) >= 0) msg = input.getAttribute('data-ph-weekday-msg') || ''; }
      input.setCustomValidity(msg);
    };
    input.addEventListener('input', check);
    input.addEventListener('change', function () { check(); if (input.validationMessage) input.reportValidity(); });
  }
  function scanForms() { document.querySelectorAll('input[data-ph-weekday]').forEach(setupWeekday); }

  function showPosted() {
    var hash = (location.hash || '').replace('#', '');
    if (!hash) return;
    document.querySelectorAll('.ph-b2-ok, .ph-b2-err').forEach(function (el) {
      if (el.getAttribute('data-form') !== hash) { el.hidden = true; return; }
      var dlg = el.closest('dialog');
      if (dlg && typeof dlg.showModal === 'function' && !dlg.open) { try { dlg.showModal(); } catch (e) {} }
    });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest ? e.target.closest('[data-ph-open]') : null;
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-ph-open'));
      if (dlg && typeof dlg.showModal === 'function') { e.preventDefault(); dlg.showModal(); }
      return;
    }
    var closer = e.target.closest ? e.target.closest('[data-ph-close]') : null;
    if (closer) { var d = closer.closest('dialog'); if (d) d.close(); return; }
    if (e.target && e.target.tagName === 'DIALOG' && e.target.classList.contains('ph-b2-dialog')) {
      var r = e.target.getBoundingClientRect();
      var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) e.target.close();
    }
  });

  function prefillInterest() {
    if (location.hash !== '#afspraak') return;
    var m = location.search.match(/[?&]product=([^&]+)/);
    if (!m) return;
    var field = document.querySelector('#afspraak input[name="contact[Interesse]"]');
    if (field && !field.value) { try { field.value = decodeURIComponent(m[1].split('+').join(' ')); } catch (e) {} }
  }
  function init() { scanEta(); scanForms(); showPosted(); prefillInterest(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  new MutationObserver(function () { queueEta(); scanForms(); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ===== B2 ronde 2 (2026-10-14): taalpad voor vaste links en verwijzing naar de vergelijker ===== */
(function () {
  function rootLinks() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root === '/') return;
    document.querySelectorAll('a[data-ph-rl]:not([data-ph-rl-done])').forEach(function (a) {
      var h = a.getAttribute('href') || '';
      if (h.charAt(0) === '/' && h.indexOf(root) !== 0) a.setAttribute('href', root.replace(/[/]$/, '') + h);
      a.setAttribute('data-ph-rl-done', '1');
    });
  }
  function compareJump() {
    var cmp = document.querySelector('[data-ph-cmp]');
    var hero = document.querySelector('.ph-ch__wrap');
    if (!cmp || !hero || hero.querySelector('.ph-cmp-jump')) return;
    var a = document.createElement('a');
    a.className = 'ph-cmp-jump';
    a.href = '#' + cmp.id;
    a.textContent = (cmp.getAttribute('data-ph-cmp-jump') || '') + ' ›';
    hero.appendChild(a);
  }
  function run() { rootLinks(); compareJump(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
